import {Component, Inject, Input} from 'ng-metadata/core';
import {PhysicalBestOfferService} from '../physicalBestOffer/physicalBestOffer.service';
import {BestOffer, mmsIdOfferOutputMap} from "../BestOffer.interface";


const get= require('lodash/get');

@Component({
    "selector": "prm-ngrs-brief-result-Line",
    templateUrl: 'components/search/fullView/ngrs/ngrsBriefResultLine/ngrsBriefResultLine.html'
})

export class PrmNgrsBriefResultLine{

    @Input() item:Object;
    
    private supplyTime:number;
    private loanPeriod:number;
    private offerFound:Boolean = false;
    private digitalOfferFound:Boolean = false;
    private _openPhysicalForm: Object;
    private _openDigitalForm: Object;
    private _openBlankForm: Object;
    private _getItFormOpen: Object;
    private _physicalBestOffer:BestOffer;
    private _digitalBestOffer: BestOffer;
    private _mmsId: string;

    constructor (private physicalBestOfferService: PhysicalBestOfferService){

        let mmsIdArr = get(this.item,'pnx.control.sourcerecordid');
        if(mmsIdArr){
            this._mmsId = mmsIdArr[0];
            this.physicalBestOfferService.getbestOffer(this._mmsId,this.item, null, null, false).then((response)=>this.setbestOffer(response));
        }
    }

    ngOnInit(){
        this._openPhysicalForm = {openPhysicalForm:false};
        this._openDigitalForm = {openDigitalForm:false};
        this._getItFormOpen={getItFormOpen:false};
        this._openBlankForm= {openBlankForm:false};
        this._physicalBestOffer=<BestOffer>{};
        this._digitalBestOffer=<BestOffer>{};
    }


     
    private setbestOffer(response:mmsIdOfferOutputMap[]){
        if(response[this._mmsId]) {
            this._physicalBestOffer = response[this._mmsId].bestPhysicalPolicy;
            this._digitalBestOffer = response[this._mmsId].bestDigitalPolicy;
            this.offerFound = this.isPhysicalOfferFound(this._physicalBestOffer);
            this.digitalOfferFound = this.isDigitalOfferFound(this._digitalBestOffer);
            this.saveOffersToService(response);
        }
    }

    private saveOffersToService(response:mmsIdOfferOutputMap[]) {
        this.physicalBestOfferService.setResultsObject(response,this._mmsId);
    }

    public getDigitalSupplyTime(){
        return this._digitalBestOffer? this._digitalBestOffer.supplyTime:0;
    }

    private  isPhysicalOfferFound(physicalBestOffer: BestOffer):boolean {
        return physicalBestOffer &&  physicalBestOffer.supplyTime >= 0  && physicalBestOffer.loanPeriod >= 0;
    }

    private isDigitalOfferFound(digitalBestOffer: BestOffer):boolean {
        return digitalBestOffer && digitalBestOffer.supplyTime>=0;
    }

    public getSupplyTime(){
        return this._physicalBestOffer? this._physicalBestOffer.supplyTime:0;
    }

    public getLoanPeriod(){
        return this._physicalBestOffer? this._physicalBestOffer.loanPeriod:0;
    }

    public isOfferFound(){
        return this.offerFound;
    }
    
    public showPhysicalForm() {
        return this._openPhysicalForm.openPhysicalForm;
    }

    public showDigitalForm() {
        return this._openDigitalForm.openDigitalForm;
    }


}








// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/ngrsBriefResultLine/ngrsBriefResultLine.directive.ts